import React from 'react'
import CarHirePageCarousels from './CarHirePageCarousels'
import useOrderCarHire from 'hooks/CarHire/useOrderCarHire'

function CarHirePageUpcomingTripCarousels() {
  const { uniqueHotelOrder } = useOrderCarHire()

  return (
    <>
      {uniqueHotelOrder &&
        <CarHirePageCarousels orderView={uniqueHotelOrder} />
      }
    </>
  )
}

export default CarHirePageUpcomingTripCarousels
